<template>
    <v-window-item :value="1" class="pl-5">
        <v-card-title class="pl-0">{{ translations.createAccount[lang] }}</v-card-title>
        <v-form @submit.prevent="createAccount">
            <v-row no-gutters class="pl-0">
                <v-col cols="4">
                    
                    <v-select
                        v-model="storeDetails.country_id"
                        :items="countries"
                        item-value="country_id"
                        menu-props="offsetY"
                        :label="translations.country[lang]"
                        color="secondary"
                        item-color="secondary"
                        :success="success.country"
                        :error-messages="error.country"
                        @focus="error.country = ''"
                        @blur="validateCountry"
                    >
                        <template v-slot:selection="{ item }">
                            <v-row
                                no-gutters
                                justify="space-between"
                                align="center"
                                style="width: 100%"
                            >
                                <v-col cols="auto">
                                    <v-img :src="item.flag" width="25"></v-img>
                                </v-col>

                                <v-col cols="auto">
                                    {{ item.code }}
                                </v-col>

                                <v-col cols="auto">
                                    {{ item.phone_code }}
                                </v-col>
                            </v-row>
                        </template>
                        <template v-slot:item="{ item }">
                            <v-row no-gutters>
                                <v-col class="mr-3">
                                    <img
                                        :src="item.flag"
                                        width="25"
                                        style="vertical-align: middle"
                                        class="mr-3"
                                    />
                                    {{ item.name }} ({{ item.code }})
                                </v-col>

                                <v-col cols="auto"
                                    >{{ item.phone_code }}</v-col
                                >
                            </v-row>
                        </template>
                    </v-select>
                </v-col>

                <v-col class="pl-5" cols="8">
                    <v-text-field
                        v-model="mobile"
                        :label="translations.mobile[lang]"
                        color="secondary"
                        clearable
                        validate-on-blur
                        :prepend-inner-icon="icons.mdiCellphoneIphone"
                        :success="success.mobile"
                        :error-messages="error.mobile"
                        @focus="error.mobile = ''"
                        @blur="validateMobile"
                    ></v-text-field>
                </v-col>

                <v-row>
                    <v-checkbox
                        v-model="tos"
                        color="secondary"
                        :success="success.tos"
                        :error-messages="error.tos"
                    ></v-checkbox>

                    <span
                        class="d-flex align-center pointer"
                        @click="tos = !tos"
                    >
                    {{ translations.iAcceptThe[lang] }}                        
                    <a
                            class="blue--text mx-1"
                            target="blank"
                            :href="termsUrl"
                        >
                            {{ translations.terms[lang] }}
                        </a>
                        {{ translations.and[lang] }}
                        <a
                            class="blue--text ml-1"
                            target="blank"
                            :href="privacyPolicyUrl"
                        >
                            {{ translations.policy[lang] }}</a
                        >
                    </span>
                </v-row>
            </v-row>

            <v-alert v-if="errorMessage" type="error">{{
                errorMessage
            }}</v-alert>

            <v-card-actions class="px-0">
                {{ translations.alreadyAccount[lang] }}
                <router-link :to="`/${lang}/sign-in`" class="blue--text mx-1"
                    >{{ translations.signIn[lang] }}</router-link
                >
                {{ translations.here[lang] }}.
                <v-spacer></v-spacer>
                <v-btn
                    type="submit"
                    color="secondary"
                    tile
                    class="px-5"
                    :loading="loading"
                    :disabled="!valid"
                    >{{ translations.register[lang] }}</v-btn
                >
            </v-card-actions>
        </v-form>
    </v-window-item>
</template>

<script>
import { mdiMenuDown, mdiMenuUp, mdiCellphoneIphone } from "@mdi/js";
import { mapState, mapMutations, mapActions } from "vuex";
import validators from "@/utils/validators/general/createAccount";
import translations from "@/utils/translations/register/createAccount";

export default {
    name: "CreateAccount",

    mixins: [validators, translations],

    data() {
        return {
            icons: { mdiMenuDown, mdiMenuUp, mdiCellphoneIphone },
            menu: false,
        };
    },

    computed: {
        ...mapState("register", [
            "loading",
            "errorMessage",
            "countries",
            "storeDetails",
            "privacyPolicyUrl",
            "termsUrl",
        ]),

        lang() {
            return this.$route.params.lang;
        },

        mobile: {
            get() {
                return this.$store.state.register.mobile;
            },

            set(val) {
                this.setMobile(val);
            },
        },

        tos: {
            get() {
                return this.$store.state.register.tos;
            },

            set(val) {
                this.setTos(val);
            },
        },
    },

    methods: {
        ...mapMutations("register", ["setMobile", "setTos"]),
        ...mapActions("register", ["getCountries","getPolicyAndTerms", "createAccount"]),
    },

    mounted() {
        this.getCountries();
        this.getPolicyAndTerms();
    },
};
</script>
